import './AboutUs.css';
import React, { useState, useEffect } from 'react';
import { useLoader } from '../pages/modules/Component/Context/LoaderProvider.jsx';

const AboutUs = () => {
  const [aboutUsText, setAboutUsText] = useState('');
  const [aboutUsImage, setAboutUsImage] = useState('');
  const [hasData, setHasData] = useState(false);
  const [loading, setLoading] = useState(true);

  const { showLoader, hideLoader } = useLoader();
  const vendorId = localStorage.getItem("vendorId");
  const token = localStorage.getItem("authToken");

  // Fetch About Us data
  const fetchAboutUs = async () => {
    if (!vendorId || !token) {
      console.log("Missing vendorId or token");
      setLoading(false);
      return;
    }

    try {
      showLoader();
      
      const response = await fetch(`https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        if (response.status === 404) {
          setHasData(false);
          setLoading(false);
          return;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data && data.aboutUsId) {
        setHasData(true);
        setAboutUsText(data.aboutUs || '');
        let imageUrl = data.image || '';
        setAboutUsImage(imageUrl);
      } else {
        setHasData(false);
        setAboutUsText('');
        setAboutUsImage('');
      }
    } catch (error) {
      console.error("Error fetching about us:", error);
      setHasData(false);
      setAboutUsText('');
      setAboutUsImage('');
    } finally {
      setLoading(false);
      hideLoader();
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchAboutUs();
  }, []);

  if (loading) {
    return (
      <div className="about-us-container">
        <div className="about-us-loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="about-us-container">
      <div className="about-us-card">
        <div className="about-us-grid">
          {/* Image Section */}
          <div className="about-us-image-section">
            <div className="about-us-image-wrapper">
              <div className="about-us-image-container">
                {aboutUsImage ? (
                  <img 
                    src={aboutUsImage} 
                    alt="About Us" 
                    className="about-us-image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '';
                    }}
                  />
                ) : (
                  <div className="about-us-image-placeholder">
                    <svg className="about-us-placeholder-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" />
                      <circle cx="8.5" cy="8.5" r="1.5" />
                      <polyline points="21 15 16 10 5 21" />
                    </svg>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Text Section */}
          <div className="about-us-text-section">
            <div className="about-us-text-wrapper">
              <h2 className="about-us-heading">About Our Company</h2>
              
              <div className="about-us-text-display">
                <p>
                  {hasData && aboutUsText 
                    ? aboutUsText 
                    : "Welcome to our company. We are committed to delivering high-quality services and innovative solutions that help businesses and individuals grow and succeed. Our mission is to provide excellence in every service we offer while building long-term, trustworthy relationships with our clients."
                  }
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;